import React, { useRef, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { Video } from '../types';
import { API_BASE_URL } from '../services/api';

interface VideoPlayerProps {
  show: boolean;
  onHide: () => void;
  video: Video;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ show, onHide, video }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playbackRate, setPlaybackRate] = React.useState(1);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = playbackRate;
    }
  }, [playbackRate]);

  const handleRateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPlaybackRate(parseFloat(e.target.value));
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Видео</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <video
          ref={videoRef}
          controls
          autoPlay
          style={{ width: '100%' }}
          src={`${API_BASE_URL}${video.video_url}`}
        />
        <Form.Group className="mt-3">
          <Form.Label>Скорость воспроизведения</Form.Label>
          <Form.Select value={playbackRate} onChange={handleRateChange}>
            <option value={0.5}>0.5x</option>
            <option value={1}>1x</option>
            <option value={1.5}>1.5x</option>
            <option value={2}>2x</option>
            <option value={4}>4x</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
    </Modal>
  );
};

export default VideoPlayer;